//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vue-github-buttons/dist/vue-github-buttons.css'; // Stylesheet
import VueGitHubButtons from 'vue-github-buttons';
import Vue from 'vue';
Vue.use(VueGitHubButtons, { useCache: true });

export default ({
	props: {
		// Settings drawer visiblility status.
		showSettingsDrawer: {
			type: Boolean,
			default: false,
		},
		
		// Main sidebar color.
		sidebarColor: {
			type: String,
			default: "primary",
		},
		
		// Main sidebar theme : light, white, dark.
		sidebarTheme: {
			type: String,
			default: "light",
		},

		// Header fixed status.
		navbarFixed: {
			type: Boolean,
			default: false,
		},

		// Drawer direction.
		rtl: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			// The wrapper element to attach dropdowns to.
			wrapper: document.body,
			
			// Main sidebar color.
			sidebarColorModel: this.sidebarColor,
			
			// Main sidebar theme : light, white, dark.
			sidebarThemeModel: this.sidebarTheme,

			// Header fixed status.
			navbarFixedModel: this.navbarFixed,
		}
	},
	mounted: function(){
		// Set the wrapper to the proper element, layout wrapper.
		this.wrapper = document.getElementById('layout-dashboard') ;
	},
})

